var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-map-content"},[_c('div',{staticClass:"main"},[_c('vj-map',{ref:"map"}),_c('router-view')],1),_c('div',{staticClass:"aside"},[_c('right-block')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }